import React, { useState } from "react";
import PageHeader from '../../components/Layout/PageHeader';
import { Doughnut,Pie,Line,Bar } from 'react-chartjs-2';
import Papa from "papaparse";



import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    title: {
      display: false,
      text: 'Line Chart',
    },
  },
};



const Chart = () => {
  const allowedExtensions = ["csv"];
  const [chartType,setChartType]=useState("Bar");
  // This state will store the parsed data
  const [upload, setUpload] = useState(true);
  const [jsonData, setJsonData] = useState([]);
     
  // It state will contain the error when
  // correct file extension is not used
  const [error, setError] = useState("");

  const setGenderVal = (value) => {
    console.log(value);
    setChartType(value);
  };


  const handleFileChange = (e) => {
    setError("");
     
    // Check if user has entered the file
    if (e.target.files.length) {
        const inputFile = e.target.files[0];
         
        // Check the file extensions, if it not
        // included in the allowed extensions
        // we show the error
        const fileExtension = inputFile?.type.split("/")[1];
        if (!allowedExtensions.includes(fileExtension)) {
            setError("Please select a csv file");
            return;
        }

        const reader = new FileReader();
         
        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
            const csv = Papa.parse(target.result, { header: true });
            const parsedData = csv?.data;
            const columns = Object.keys(parsedData[0]);
            const label=columns[0];
            const data=csv.data;
            let columns1 = columns.slice(1,columns.length);
            console.log(columns1);
            setJsonData([]);
            for(let i=0;i<data.length;i++)
            {
              if(Object.keys(data[i]).length>3)
              {
                let labelValue=data[i][label].toUpperCase();
                delete data[i][label];
                let dataArray=[];
                let dt=data[i];
                Object.keys(dt).map(
                  (key) => dataArray.push(dt[key])
                );
                setJsonData((jsonData)=>[
                  ...jsonData,
                  {
                    index:(i+1)%3,
                    label:labelValue,
                    graphData : {
                      labels: columns1,
                      datasets: [
                        {
                          label: 'Label : '+labelValue,
                          data: dataArray,
                          backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                          ],
                          borderColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                          ],
                          borderWidth: 1,
                        },
                      ],
                    }
                  }
                ]);
              }
            }
            setUpload(false);
        };
        reader.readAsText(inputFile);

        // If input type is correct set the state
        
    }
};


  
    
  return (
    <main className='flex-1 dark:bg-slate-800'>
      <PageHeader title={'Dashboard 2'} showCreateButton={false}/>
      {upload==true && (
        <div className="m-10">
          <div class="flex justify-center items-center w-full">
              <label for="csvInput" class="flex flex-col justify-center items-center w-full h-96 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600">
                  <div class="flex flex-col justify-center items-center pt-5 pb-6">
                      <svg aria-hidden="true" class="mb-3 w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                      <p class="mb-2 text-sm text-gray-500 dark:text-gray-400"><span class="font-semibold">Click to upload</span> or drag and drop</p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">Accept only CSV File</p>
                  </div>
                  <input onChange={handleFileChange} id="csvInput" name="file" type="file" class="hidden" />
              </label>
          </div> 
          <p class="mt-1 text-sm text-red-800 text-center dark:text-red-300" id="file_input_help">{error}</p>
        </div>
      )}
      {upload==false && (
        <div>
          <div className='px-4 mt-6 sm:px-6 lg:px-8'>
            <div class="grid lg:flex items-center space-y-4 lg:space-y-0">
              <div class="container mx-auto px-4 dark:text-slate-100">
                <input type="radio" name="chartType" onChange={() => setGenderVal("Bar")} value="Bar" class="required:border-red-500 dark:text-slate-100 ..." /> Bar Chart
              </div>
              <div class="container mx-auto px-4 dark:text-slate-100">
                <input type="radio" name="chartType" onChange={() => setGenderVal("Pie")} value="Pie" class="required:border-red-500 ..." /> Pie Chart
              </div>
              <div class="container mx-auto px-4 dark:text-slate-100">
                <input type="radio" name="chartType" onChange={() => setGenderVal("Doughnut")} value="Doughnut" class="required:border-red-500 ..." /> Doughnut Chart
              </div>
              <div class="container mx-auto px-4 dark:text-slate-100">
                <input type="radio" name="chartType" onChange={() => setGenderVal("Line")} value="Line" class="required:border-red-500 ..." /> Line Chart
              </div>
            </div>
          </div>
          <div className='break-after-auto	'>
              {jsonData.map((data,index)=>(
                <div className="w-full">
                  <div key={index} class="m-5">
                    
                    <div class="max-w-xl mx-auto bg-white rounded-lg border dark:bg-slate-800 border-sky-500  shadow-cyan-500/50 drop-shadow-sm shadow-sm ..." >
                      <div class="container mx-auto px-4">
                        {chartType === "Pie" && (
                          <Pie data={data.graphData} />
                        )}
                        {chartType === "Doughnut" && (
                          <Doughnut data={data.graphData} />
                        )}
                        {chartType === "Line" && (
                          <Line options={options} data={data.graphData} />
                        )}
                        {chartType === "Bar" && (
                          <Bar options={options} data={data.graphData} />
                        )}
                      </div>
                      <div class="container mx-auto text-center	mt-6 rounded-lg border dark:text-slate-100">
                      {data.label}
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </main>
  );
};

export default Chart;
